export default Object.freeze({
  Card: 1,
  BankAccount: 2,
  Invoice: 3,
});
